import LyPage from './src/index.vue'

LyPage.install = function (Vue) {
    Vue.component(LyPage.name, LyPage)
}

export default LyPage



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/page/index.js
// module id = null
// module chunks = 